const state = {
    info: {}
  }

const getters = {
    info: state => state.info
}

const actions = {
    async getInfo({dispatch, commit}){
        try{
            let response = await dispatch('doRequest', {
                endpoint: '/api/v3/ui/info'
            })
            commit('setInfo', response.response)
            return response.response
        }
        catch(error){
            console.log(error)
        }
    }
}

const mutations = {
    setInfo(state, info){
        state.info = info;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
};